import React, { Fragment } from "react";
import { Paper, withStyles } from '@material-ui/core';
import { Col, Row } from 'react-bootstrap';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    Brush
} from 'recharts';
import { statusSistemaQueries } from '../../graphql/StatusSistema'
import { Query } from "react-apollo";
import Environment from "../../environment/environment";


const styles = theme => ({
    root: {
        padding: theme.spacing(3, 2),
    },
    sessaoUsuarioContent: {
        display: 'flex',
        flexDirection: 'column',
        border: '2px solid black',
        padding: '10px',
        '& .row': {
            flexWrap: 'nowrap'
        },
        '& .row.coloredLine:nth-child(even)': {
            backgroundColor: '#f1f1f1'
        }
    },
    sessaoUsuarioContentTabTitle: {
        marginBottom: '10px'
    },
    sessaoUsuarioTotal: {
        display: 'flex',
        justifyContent: 'space-between',
        borderTop: '2px solid black',
        marginTop: '20px',
        marginBottom: '0',
    },
    firstTitle: {
        marginBottom: '30px',
        fontWeight: 'bold',
    },
    firstTitleRecursos: {
        '@media(max-width: 575px)': {
            marginTop: 30
        }
    },
    historicoHojeTitle: {
        marginBottom: '30px',
        marginTop: '30px',
        fontWeight: 'bold'
    },
    recursosUtilizadosItemBox: {
        marginBottom: '15px'
    },
    recursosUtilizadosItem: {
        boxSizing: 'border-box',
        textAlign: 'center',
        border: '3px solid black',
        padding: '15px',
        width: '100%',
        height: '100%'
    },
    recursosUtilizadosBlocks: {
        display: 'flex',
        flexWrap: 'wrap',
    },
});

class AdmStatusSistema extends React.Component {

    renderSessoesUsuarios(data) {
        let { classes } = this.props;

        const tabHeader = () => {
            return (
                <Row className={classes.sessaoUsuarioContentTabTitle}>
                    <Col>
                        <b> Organizador </b>
                    </Col>
                    <Col>
                        <b> Nome da sessão </b>
                    </Col>
                    <Col>
                        <b> Conectados </b>
                    </Col>
                </Row>
            );
        }

        const dataToDisplay = data.map((z, key) => {
            return (
                <Row
                    key={key}
                    className="coloredLine"
                >
                    <Col>
                        {z.nomeOrganizador}
                    </Col>
                    <Col>
                        {z.nomeSessao}
                    </Col>
                    <Col>
                        {z.qtdUsuariosConectados}
                    </Col>
                </Row>
            )
        });

        const sessaoUsuarioTotal = () => {
            if(!data.lenght)
                return null;

            return (
                <Row>
                    <Col>
                        <div className={classes.sessaoUsuarioTotal}>
                            <div>
                                <b> { data[0].qtdTotalSessoesConectados } </b> sessões em execução
                            </div>
                            <div>
                                <b> { data[0].qtdTotalUsuariosConectados } </b> usuários conectados
                            </div>
                        </div>
                    </Col>
                </Row>
            );
        }

        return (
            <Fragment>
                <Row>
                    <Col>
                        <h5 className={classes.firstTitle}>Sessões e usuários</h5>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className={classes.sessaoUsuarioContent}>
                            {tabHeader()}
                            {dataToDisplay}
                            {sessaoUsuarioTotal()}
                        </div>
                    </Col>
                </Row>
            </Fragment>
        );
    }

    renderHistoricoHoje(data) {
        let { classes } = this.props;

        data = data.map( z => ({ ...z, horario: Environment.momentToLocalTimeString(z.horario)}) );

        if (!this.graficoZoom) {
            this.graficoZoom = {
                startIndex: null,
                endIndex: null
            };
        }

        return (
            <Fragment>
                <Row>
                    <Col>
                        <h5 className={classes.historicoHojeTitle}>Histórico de hoje</h5>
                    </Col>
                </Row>
                <Row>
                    <Col
                        style={{
                            height: '40vh'
                        }}
                    >
                        <ResponsiveContainer>
                            <LineChart
                                data={data}
                                margin={{
                                    top: 5,
                                    right: 10,
                                    left: 0,
                                    bottom: 5,
                                }}
                            >
                                <XAxis dataKey="horario" />
                                <YAxis width={30} yAxisId="left" />
                                <YAxis width={30} yAxisId="right" orientation="right" />
                                <CartesianGrid strokeDasharray="3 3" />
                                <Tooltip />
                                <Legend verticalAlign="bottom" height={36} />
                                <Line
                                    yAxisId="left"
                                    type="monotone"
                                    name={"Usuários conectados"}
                                    dataKey="usuariosConectados"
                                    stroke="#8884d8"
                                    activeDot={{ r: 8 }}
                                />
                                <Line
                                    yAxisId="right"
                                    type="monotone"
                                    name={"Sessões em execução"}
                                    dataKey="sessoesExecucao"
                                    stroke="#82ca9d"
                                />

                                <Brush
                                    dataKey='horario'
                                    stroke="#000000"
                                    startIndex={this.graficoZoom.startIndex}
                                    endIndex={this.graficoZoom.endIndex}
                                    onChange={ (index) => {
                                        this.graficoZoom = index;
                                    }}
                                >
                                    <LineChart>
                                        <Line
                                            yAxisId="left"
                                            type="monotone"
                                            name={"Usuários conectados"}
                                            dataKey="usuariosConectados"
                                            stroke="#8884d8"
                                            activeDot={{ r: 8 }}
                                        />
                                        <Line
                                            yAxisId="right"
                                            type="monotone"
                                            name={"Sessões em execução"}
                                            dataKey="sessoesExecucao"
                                            stroke="#82ca9d"
                                        />
                                    </LineChart>
                                </Brush>

                            </LineChart>
                        </ResponsiveContainer>
                    </Col>
                </Row>
            </Fragment>
        )
    }

    renderRecursosUtilizados(data) {
        let { classes } = this.props;

        const dadosBloco = data.map((z, key) => {
            return (
                <Col xs={6} key={key} className={classes.recursosUtilizadosItemBox}>
                    <div className={classes.recursosUtilizadosItem}>
                        <h4 style={{ color: z.color }}>{z.value}</h4>
                        <span>{z.title}</span>
                    </div>
                </Col>
            )
        });

        return (
            <Fragment>
                <Row>
                    <Col>
                        <h5 className={`${classes.firstTitle} ${classes.firstTitleRecursos}`}>Indicadores</h5>
                    </Col>
                </Row>
                <Row className={classes.recursosUtilizadosBlocks}>
                    {dadosBloco}
                </Row>
            </Fragment>
        )
    }

    render() {
        let { classes } = this.props;

        let params = {
            today: Environment.startOfCurrentDay()
        };

        return (
            <Query query={statusSistemaQueries} variables={ params }  pollInterval={5000}>
                {({ data, loading, error, refetch }) => {
                    if (loading) return 'Carregando ...';
                    if (error) return `Error! ${error.message}`;

                    return (
                        <Paper className={classes.root}>
                            <Row>
                                <Col xs={12} sm={8}>
                                    {this.renderSessoesUsuarios(data.statusSessoesAtuais)}
                                    {this.renderHistoricoHoje(data.statusHistoricoHoje)}
                                </Col>
                                <Col xs={12} sm={4}>
                                    {this.renderRecursosUtilizados(data.statusRecursosUtilizados)}
                                </Col>
                            </Row>
                        </Paper>
                    );
                }}
            </Query>
        );
    }
}

export default (withStyles(styles)(AdmStatusSistema));